import { nanoid } from "nanoid"

import type { Point2d } from ".."

export type NameVirtualNode = (node: Point2d, idx: number) => string

export const nameVirtualNode: NameVirtualNode = (_, idx) =>
  `VIRTUAL_${idx}_${nanoid(5)}`
